module.exports = __webpack_public_path__ + "static/media/29FUNOV5.6a47cb20.jpg";